import { ButtonLink } from "@clarkinc/zest-design-system/ui";
import React, { PropsWithChildren } from "react";
import { DocumentSummary } from "./Models";
const ResourceLink = ({
  id,
  resourceUri,
  children
}: PropsWithChildren<DocumentSummary>) => {
  return <ButtonLink target="_blank" iconProps={{
    "aria-hidden": true,
    name: "ri-external-link-line"
  }} iconPosition="left" key={id} href={resourceUri} theme="wss" variant="primary" color="white" className="mr-2 mt-2.5" size="medium" data-testid={`pdp-chatbot-document-link-${id}`} style={{
    fontFamily: "inherit"
  }} data-sentry-element="ButtonLink" data-sentry-component="ResourceLink" data-sentry-source-file="ResourceLink.tsx">
      {children}
    </ButtonLink>;
};
export default ResourceLink;